import { IInventory, Inventory, IPrice, Price } from "..";

export interface IOnlineStoreData {
    brcode?: number;
    visibility: boolean;
    price?: IPrice;
    inventory?: IInventory;
}

export interface IOnlineStore extends IOnlineStoreData {
    setPrice(price: Price): void
    setInventory(inventory: Inventory): void
}

export class OnlineStore implements IOnlineStore {
    brcode?: number;
    visibility: boolean;
    price?: IPrice;
    inventory?: IInventory;

    constructor(data: IOnlineStoreData) {
        this.brcode = data.brcode
        this.visibility = data.visibility
    }
    setPrice(price: Price): void {
        this.price = price
    }
    setInventory(inventory: Inventory): void {
        this.inventory = inventory
    }

}